import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Tooltip from 'components/Tooltip';
import { useDispatch } from 'react-redux';
import { setCurrentSubscriptionIndex } from 'store/actions/subscription';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBox } from '@fortawesome/free-solid-svg-icons/faBox';
import moment from 'moment';
import themeObj from 'themes/specsavers';
import RadioButton from './RadioButton';

const Wrapper = styled.button`
  background-color: transparent;
  border: none;
  border-radius: ${({ theme }) => theme.shape.borderRadius}px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.4rem;
  outline: none;
  position: relative;

  .subscriptionsCount {
    position: absolute;
    color: white;
    left: calc(50% - 0.25em);
    bottom: ${({ theme }) => theme.spacing * 2}px;
    font-size: 12px;
  }
`;

const SubscriptionComponent = styled(RadioButton)`
  align-items: center;
  margin-bottom: 0.4em;
  padding: 0.2em 0;
  .radioUiWrapper {
    margin-right: 0.5em;
  }
`;

const TooltipTitle = styled.h3`
  margin-top: 0;
`;

const SubscriptionsSwitch = ({
  className, subscriptions, selectedIndex,
}) => {
  const classes = ['SubscriptionsSwitch'];
  const [showTooltip, setShowTooltip] = React.useState(false);
  const buttonRef = React.useRef();
  const dispatch = useDispatch();

  function toggleTooltip() {
    setShowTooltip(!showTooltip);
  }
  function setCurrentIndex(e) {
    toggleTooltip();
    dispatch(setCurrentSubscriptionIndex(parseInt(e.target.value, 10)));
  }
  if (className) classes.push(className);

  return (
    <Wrapper
      className={classes.join(' ')}
      onClick={toggleTooltip}
      ref={buttonRef}
    >
      <FontAwesomeIcon icon={faBox} />
      <span className="subscriptionsCount">{subscriptions.length}</span>
      {showTooltip && (
        <Tooltip
          anchorToRef={buttonRef}
          onClose={() => setShowTooltip(false)}
          align="bottom"
          zIndex={themeObj.zIndex.header}
        >
          <TooltipTitle>{`Your ${subscriptions.length} subscriptions:`}</TooltipTitle>
          {subscriptions.map((s, index) => {
            const pack = s.packs[s.packs.length - 1];
            const validUntil = pack.payments[pack.payments.length - 1].payment_date;
            return (
              <SubscriptionComponent name="subscription" key={s.id} value={index} onChange={setCurrentIndex} checked={selectedIndex === index}>
                Valid until:&nbsp;
                {moment(validUntil).format('DD MMMM YYYY')}
              </SubscriptionComponent>
            );
          })}
        </Tooltip>
      )}
    </Wrapper>
  );
};

SubscriptionsSwitch.displayName = 'SubscriptionsSwitch';

SubscriptionsSwitch.propTypes = {
  className: PropTypes.string,
  subscriptions: PropTypes.arrayOf(PropTypes.object).isRequired,
  selectedIndex: PropTypes.number,
};

SubscriptionsSwitch.defaultProps = {
  className: null,
  selectedIndex: 0,
};

export default SubscriptionsSwitch;
